import React from 'react';

import { passPropsToChildrens } from '../components/common/utils/DOM';

import { Features, isFeatureEnabled } from './features';

interface IFeatureToggleParams {
  children: React.ReactElement[];
  feature: Features;
}
export const FeatureToggle = ({
  children,
  feature
}: IFeatureToggleParams): JSX.Element | null => {
  if (!feature) {
    return null;
  }

  const featureToggleEnabled = isFeatureEnabled(feature);
  const toggledChildren = passPropsToChildrens(children, { featureToggleEnabled });

  return <>{toggledChildren}</>;
};

interface IOnOffProps {
  children?: React.ReactNode;
  featureToggleEnabled?: boolean;
}

export const Off = ({ children, featureToggleEnabled = false }: IOnOffProps): JSX.Element | null => {
  if (featureToggleEnabled) {
    return null;
  }
  return <>{children || null}</>;
};

export const On = ({ children, featureToggleEnabled = false }: IOnOffProps): JSX.Element | null => {
  if (!featureToggleEnabled) {
    return null;
  }
  return <>{children || null}</>;
};
